import React, { Component } from 'react'

import cn from 'classnames'
import PropTypes from 'prop-types'
import TextInputElement from 'components/forms/TextInputElement'
import TextAreaElement from 'components/common/ResizeableTextarea'
import Button from 'components/common/Button'
import EventList from './EventList/EventList'
import HobnobModal from 'components/common/HobnobModal'

import LabelIcon from 'assets/icons/label-icon.png'
import BalloonIcon from 'assets/icons/balloon-icon.png'
import RightIcon from 'assets/icons/right-icon.png'
import StrokeIcon from 'assets/icons/stroke-icon.png'
import NotesIcon from 'assets/icons/notes-icon.png'
import RightIconWhite from 'assets/icons/right-icon-white.png'
import { connect } from 'react-redux'
import { changeSignUpForm } from 'src/actions/timepoll'
import { fetchEventByDraftAndMe } from 'src/actions'
import styles from './first-step.scss'

const tagList = ['potluck', 'wishlist', 'volunteer']

class FirstStep extends Component {
  state = {
    eventList: [],
    isOpenEventModal: false
  }

  _handleChange = (type, value) => {
    const { onChangeSignUpForm, signUpForm } = this.props
    onChangeSignUpForm({ ...signUpForm, [type]: value })
  }

  componentDidMount() {
    this.props.getEventList({
      onSuccessCallback: data => {
        this.setState({ eventList: data.data.me.events_connection.events })
      }
    })
  }

  render() {
    const { onButtonClick, signUpForm } = this.props
    const { isOpenEventModal, eventList } = this.state

    return (
      <div className={styles['first-step-container']}>
        <div className={styles['name-wrapper']}>
          <div className={styles['input-wrapper']}>
            <img src={LabelIcon} alt="" width="18" />
            <TextInputElement
              className={styles['input-inner']}
              placeholder="Name Your Sign Up List"
              onChange={event => this._handleChange('name', event.target.value)}
              valid
              value={signUpForm.name}
            />
          </div>

          <ul className={styles['name-list']}>
            {tagList.map((item, index) => (
              <li
                onClick={() => this._handleChange('name', item)}
                className={cn(styles['name-item'], {
                  [styles['name-item-checked']]: item === signUpForm.name
                })}
                key={index}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className={styles['information-wrapper']}>
          <div className={styles['information-label']}>optional</div>

          <div
            className={styles['input-wrapper']}
            onClick={() => this.setState({ isOpenEventModal: true })}
          >
            <img src={BalloonIcon} alt="" width="20" />
            <TextInputElement
              className={styles['input-inner']}
              placeholder="Event"
              onChange={() => {}}
              valid
              value={signUpForm.checkedEvent?.name || ''}
              readOnly
            />
            <img src={RightIcon} width="20" />
          </div>

          <div className={styles['input-wrapper']}>
            <img src={StrokeIcon} alt="" width="20" />
            <TextInputElement
              className={styles['input-inner']}
              placeholder="Custom Creator Name"
              valid
              value={signUpForm.custom_creator_name}
              onChange={event => this._handleChange('custom_creator_name', event.target.value)}
            />
          </div>

          <div className={cn(styles['input-wrapper'], styles['textArea-wrapper'])}>
            <img src={NotesIcon} alt="" width="22" />
            <TextAreaElement
              className={styles['textArea-inner']}
              placeholder="Notes"
              onChangeComment={value => this._handleChange('notes', value)}
              comment={signUpForm.notes}
            />
          </div>
        </div>
        <div className={styles['button-wrapper']}>
          <Button className={styles['button-inner']} onClick={onButtonClick}>
            <span>next</span>
            <img src={RightIconWhite} alt="" width="24" />
          </Button>
        </div>
        <HobnobModal
          show={isOpenEventModal}
          onClose={() => this.setState({ isOpenEventModal: false })}
        >
          <EventList
            onClose={() => this.setState({ isOpenEventModal: false })}
            eventList={eventList}
          />
        </HobnobModal>
      </div>
    )
  }
}

FirstStep.propTypes = {
  onButtonClick: PropTypes.func,
  signUpForm: PropTypes.object,
  onChangeSignUpForm: PropTypes.func,
  getEventList: PropTypes.func
}

function mapStateToProps(state) {
  return {
    signUpForm: state.frontend.signUpForm
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeSignUpForm: params => dispatch(changeSignUpForm(params)),
    getEventList: params => dispatch(fetchEventByDraftAndMe(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FirstStep)



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/SignUp/CreateSignUp/FirstStep/FirstStep.jsx